import { Tabs as TabsPrimitive } from "radix-ui";
import * as React from "react";

import { cn } from "~/components/ui/cn";

const Tabs = TabsPrimitive.Root;

const TabsList: React.FC<React.ComponentProps<typeof TabsPrimitive.List>> = ({
  className,
  ...props
}) => (
  <TabsPrimitive.List
    className={cn("inline-flex flex-1 items-center gap-x-2", className)}
    {...props}
  />
);
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger: React.FC<
  React.ComponentProps<typeof TabsPrimitive.Trigger>
> = ({ children, className, ...props }) => (
  <TabsPrimitive.Trigger
    className={cn(
      "group inline-flex items-center justify-center whitespace-nowrap border-b-2 border-transparent px-1 pb-1 pt-1.5 text-base font-semibold leading-5.5 text-[#767A7C] focus-visible:outline-none data-[hidden=true]:hidden data-[state=active]:border-green-900 data-[state=active]:text-green-900",
      className,
    )}
    {...props}
  >
    <div className="flex gap-2 rounded-sm px-1 py-0.5 group-hover:bg-gray-50 group-focus-visible:rounded-sm group-focus-visible:shadow-[0_0_0_4px_#ECECEC]">
      {children}
    </div>
  </TabsPrimitive.Trigger>
);
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent: React.FC<
  React.ComponentProps<typeof TabsPrimitive.Content>
> = ({ className, ...props }) => (
  <TabsPrimitive.Content className={cn("mt-4", className)} {...props} />
);
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
